export const UPDATE_PRESENCAS = 'UDPATE_PRESENCAS'
export const ADD_PRESENCAS = 'ADD_PRESENCAS'
export const SET_PRESENCAS = 'SET_PRESENCAS'
export const REMOVE_PRESENCAS = 'REMOVE_PRESENCAS'
export const SET_PRESENCA = 'SET_PRESENCA'
export const SET_PRESENCA_NULL = 'SET_PRESENCA_NULL'